var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tasks uk-container"},[_c('div',{staticClass:"uk-flex uk-flex-between uk-flex-wrap uk-margin-large-bottom uk-margin-large-top"},[_c('FilterInput'),_c('NewTask')],1),_c('Tasks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }